export default function Footer() {
  return (
    <footer id="contact" className="bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white border-t border-amber-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-16 mb-16">
          {/* 左側:クリニック情報 */}
          <div>
            <h3 className="text-3xl font-bold mb-8 bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              <i className="ri-vip-crown-line mr-2"></i>
              神戸、生野でインプラントするなら
            </h3>
            
            <div className="space-y-6 mb-10">
              <div className="flex items-start p-4 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
                <i className="ri-map-pin-line text-amber-400 text-2xl mr-4 mt-1 flex-shrink-0"></i>
                <div className="text-gray-300 font-light space-y-3">
                  <p>
                    〒658-0033<br />
                    神戸市東灘区深江南町1-12-16<br />
                    光南ハイツ1階
                  </p>
                  <p>
                    〒544-0033<br />
                    大阪市生野区勝山北1-3-19
                  </p>
                </div>
              </div>
              
              <div className="space-y-4">
                <h4 className="text-lg font-bold text-slate-800 mb-4">お電話でのご予約</h4>
                <div className="space-y-3">
                  <div>
                    <p className="text-sm text-gray-400 mb-1">LIOデンタルクリニック</p>
                    <a href="tel:078-453-0828" className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent hover:from-amber-500 hover:to-yellow-600 whitespace-nowrap">
                      078-453-0828<span className="text-base ml-2">(神戸)</span>
                    </a>
                  </div>
                  <div>
                    <p className="text-sm text-gray-400 mb-1">いくの歯科医院</p>
                    <a href="tel:06-6777-6714" className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-yellow-500 bg-clip-text text-transparent hover:from-amber-500 hover:to-yellow-600 whitespace-nowrap block">
                      06-6777-6714<span className="text-base ml-2">(大阪)</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 右側:アクセスマップ */}
          <div>
            <h4 className="font-bold mb-6 text-xl text-amber-400" style={{ fontFamily: '"Noto Serif JP", serif' }}>アクセス</h4>
            
            {/* 2つのクリニックを横並びに */}
            <div className="grid md:grid-cols-2 gap-6">
              {/* LIOデンタルクリニック（神戸）*/}
              <div>
                <h5 className="text-lg font-semibold text-white mb-4">LIOデンタルクリニック（神戸）</h5>
                <div className="rounded-2xl overflow-hidden shadow-2xl mb-4 border border-amber-500/20">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3280.5!2d135.29986224!3d34.72311552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDQzJzIzLjIiTiAxMzXCsDE3JzU5LjUiRQ!5e0!3m2!1sja!2sjp!4v1640995200000!5m2!1sja!2sjp" 
                    width="100%" 
                    height="200" 
                    style={{ border: 0 }} 
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="LIOデンタルクリニック アクセスマップ"
                  ></iframe>
                </div>
                <ul className="text-sm text-gray-300 space-y-2 font-light">
                  <li className="flex items-start p-3 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
                    <i className="ri-train-line text-amber-400 mr-3 mt-1 flex-shrink-0 text-lg"></i>
                    <span>阪神芦屋、深江駅徒歩8分</span>
                  </li>
                  <li className="flex items-start p-3 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
                    <i className="ri-parking-box-line text-amber-400 mr-3 mt-1 flex-shrink-0 text-lg"></i>
                    <span>駐車場完備</span>
                  </li>
                </ul>
              </div>

              {/* いくの歯科医院（大阪）*/}
              <div>
                <h5 className="text-lg font-semibold text-white mb-4">いくの歯科医院（大阪）</h5>
                <div className="rounded-2xl overflow-hidden shadow-2xl mb-4 border border-amber-500/20">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.1!2d135.5089!3d34.6937!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e0d7d7d7d7d7%3A0x1234567890abcdef!2z5aSn6Ziq5biC55Sf6YeO5Yy65Yud5bGx5YyX77yR77yN77yT77yN77yR77yZ!5e0!3m2!1sja!2sjp!4v1640995200000!5m2!1sja!2sjp" 
                    width="100%" 
                    height="200" 
                    style={{ border: 0 }} 
                    allowFullScreen 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="いくの歯科医院 アクセスマップ"
                  ></iframe>
                </div>
                <ul className="text-sm text-gray-300 space-y-2 font-light">
                  <li className="flex items-start p-3 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
                    <i className="ri-train-line text-amber-400 mr-3 mt-1 flex-shrink-0 text-lg"></i>
                    <span>JR環状線桃谷駅徒歩1分</span>
                  </li>
                  <li className="flex items-start p-3 bg-white/5 backdrop-blur-sm rounded-xl border border-white/10">
                    <i className="ri-parking-box-line text-amber-400 mr-3 mt-1 flex-shrink-0 text-lg"></i>
                    <span>提携駐車場あり</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* コピーライト */}
        <div className="border-t border-amber-500/20 pt-10 text-center">
          <p className="text-sm text-gray-400 mb-3 font-light">
            © 2024 ゆうまデンタルクリニック All Rights Reserved.
          </p>
          <p className="text-xs text-gray-500">
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-amber-400 transition-colors">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}